/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForServiceNow extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForServiceNow");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForServiceNow.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForServiceNow>): ServiceAccountNativeDetailsForServiceNow {
        let obj = Object.assign(new ServiceAccountNativeDetailsForServiceNow(), model);
        ServiceAccountNativeDetailsForServiceNow.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForServiceNow>): ServiceAccountNativeDetailsForServiceNow {
        if (!model) return null;
        return ServiceAccountNativeDetailsForServiceNow.newInstance(<ServiceAccountNativeDetailsForServiceNow> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForServiceNow) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForServiceNow.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForServiceNow): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForServiceNow.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.product_activation) {
            for (let val of this.product_activation) {
                models.IntegratedToolProductActivation.fixupPrototype(val);
            }
        }
    }

    product_activation: Array<models.IntegratedToolProductActivation>;

}
